export default __webpack_public_path__ + "static/media/SS.bef5fc69.png";